import { useEffect, useState } from 'react';
import checkVideoType from '../../../utilites/checkVideoType';
export var useGetVideoType = function (link) {
    var _a = useState(''), videoType = _a[0], setVideoType = _a[1];
    useEffect(function () {
        var typedLink = checkVideoType(link);
        setVideoType(typedLink);
        /*    if (['sc', 'v', 'yt', 'rt'].includes(typedLink)) {
              toggleVideo(true)
            }*/
    }, [link]);
    return videoType;
};
//# sourceMappingURL=useGetVideoType.js.mapimport { useEffect, useState } from 'react';
import checkVideoType from '../../../utilites/checkVideoType';
export var useGetVideoType = function (link) {
    var _a = useState(''), videoType = _a[0], setVideoType = _a[1];
    useEffect(function () {
        var typedLink = checkVideoType(link);
        setVideoType(typedLink);
        /*    if (['sc', 'v', 'yt', 'rt'].includes(typedLink)) {
              toggleVideo(true)
            }*/
    }, [link]);
    return videoType;
};
//# sourceMappingURL=useGetVideoType.js.map